export function getQueryParams(url) {
  const query = url.split('?')[1]

  if (!query) {
    return {}
  }

  const queryString = query.split('&')
  const queries = queryString.reduce((accum, bondedQuery) => {
    const pairs = bondedQuery.split('=')
    const key = pairs[0]
    const value = pairs[1]

    return { ...accum, [key]: value }
  }, {})

  return queries
}

export const stripLastRouteSlug = path => {
  let modifiedPath = path
  const lastCharacter = path.slice(-1)

  if (lastCharacter === '/') {
    modifiedPath = modifiedPath.slice(0, -1)
  }

  const pathSlugs = modifiedPath.split('/')
  pathSlugs.pop()

  const joinedPath = pathSlugs.join('/')

  return joinedPath
}

export function getSlug(title) {
  return title
    .toLowerCase()
    .split(' ')
    .join('-')
}

/**
 * Checks if the current URL contains the word "preview" (case-insensitive)
 * Used for tier-2 preview mode detection
 * @returns {boolean} True if the URL contains "preview", false otherwise
 */
export const isTier2PreviewMode = () => {
  return (
    (isTier2Url() &&
      window.location?.href?.toLowerCase().includes('preview')) ||
    false
  )
}

/**
 * Checks if the current URL contains tier-2 in the pathname
 * @returns {boolean} True if the URL contains "/tier-2", false otherwise
 */
export const isTier2Url = () => {
  return window.location?.pathname?.includes('/tier-2') || false
}

export { isDigitalWellBeingUrl } from './productHelpers'

/**
 * Checks if the current pathname is on a digital well-being preview route
 * @returns {boolean} True if the URL contains "/digital-well-being/preview/", false otherwise
 */
export const isDigitalWellBeingPreviewMode = () => {
  return (
    window.location?.pathname?.includes('/digital-well-being/preview/') || false
  )
}
